import Vue from "vue";
import "babel-polyfill"; // 兼容低版本IE,ES5模拟ES6新语法
import App from "./App.vue"; // 当前项目的挂载容器
import router from "./basa/router"; // vue路由
import store from "./config/store"; // vuex
import cascaderPanel from "ccui";
import crypto from "./basa/utils/crypto";
import globalComponents from "@/basa/common-set/globalComponents"; // 挂载的平台级公共函数
import tableList from "@/basa/common-set/table-list"; //多功能表格缓存名称
import appComponents from "@/config/app-set/appComponents"; // 自定义挂载应用级的公共函数
import CCUI from "@/config/app-set/ccui"; // ccui组件库配置文件，用来增删工程内用到的组件
import "./permission"; // 全局路由守卫等全局控制器
import "./config/icons"; // SVG
// import "./config/mock"; // mock数据
// 货币的计算方法
import currency from "currency.js";
import BigNumber from "bignumber.js";

import "@/config/styles/index.scss"; // 项目所用公共css
import * as filters from "./basa/filters"; // 全局过滤器
import functions from "./basa/utils/functions"; // 全局方法
import searchComponents from "@/basa/components/search-component"; // 高级搜索所需自定义特殊组件
import searchPriceRangeComponents from "@/basa/components/search-price-range-component"; // 高级搜索--收款金额（金额A - 金额B）
import { UxGrid } from "umy-ui"; // 大数据表格
import "umy-ui/lib/theme-chalk/ux-grid.css"; // 大数据表格样式
import "./basa/css/common.css";
import "@/basa/utils/dict"; // 数据字典
import invoiceComponents from "@/basa/components/common/invoice-component"; // 高级搜索所需自定义特殊组件--发票比例
import collectionComponent from "@/basa/components/common/collection-component"; // 高级搜索所需自定义特殊组件--收款比例
import invoiceNumber from "@/basa/components/common/invoiceNumber";
import invoiceMoney from "@/basa/components/common/invoiceMoney";
import dateTime from "@/basa/components/common/dateTime";
import VueClipboards from "vue-clipboards";
import * as echarts from "echarts";
import china from "echarts/map/json/china.json";
echarts.registerMap("china", china);
import yearRange from "@/components/year-range.js";

Number.prototype.toFixed = function(val) {
  if (this !== undefined && this !== null && this !== "") {
    return new BigNumber(this).toFixed(val); // 默认四舍五入算法
  } else {
    return "";
  }
};

// import VueMatomo from "vue-matomo"; // 访问量所需插件
// 注册全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
// 生产环境不显示vue警告信息
Vue.config.productionTip = false;
// 注册全局方法
//大数据表格
Vue.use(UxGrid);
Vue.use(VueClipboards);
// 全局方法挂载
Vue.prototype.currency = currency;
Vue.prototype.tableList = tableList;
Vue.prototype.$crypto = crypto;
Vue.prototype.$eventBus = new Vue();
Vue.prototype.$echarts = echarts;
Vue.use(functions);
// 注册ccui组件
Vue.use(yearRange);

Vue.use(CCUI);
Vue.use(searchComponents);
Vue.use(searchPriceRangeComponents);
Vue.use(cascaderPanel);
Vue.use(currency);
// 注册平台级公共组件
Vue.use(globalComponents);
// 注册一些应用级组件
Vue.use(appComponents);
Vue.use(invoiceComponents);
Vue.use(collectionComponent);
Vue.use(invoiceNumber);
Vue.use(invoiceMoney);
Vue.use(dateTime);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

Vue.prototype.resetSetItem = function(key, newVal) {
  if (key === "languageChangeHandler1") {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent("StorageEvent");
    const storage = {
      setItem: function(k, val) {
        sessionStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent(
          "setItem",
          false,
          false,
          k,
          null,
          val,
          null,
          null
        );
        // 派发对象
        window.dispatchEvent(newStorageEvent);
      }
    };
    return storage.setItem(key, newVal);
  }
};
